import api from '@/services/api';

export default {
  namespaced: true,
  state: {
    faqs: null,
    sitemap: null,
  },
  mutations: {
    setFaqs(state, payload) {
      state.faqs = payload;
    },
    setSitemap(state, payload) {
      state.sitemap = payload;
    },
  },
  actions: {
    getFaqs({ commit }) {
      return api.about.getFaqs().then((response) => {
        commit('setFaqs', response.data);
        return response.data;
      });
    },
    getSitemap({ commit }) {
      return api.about.getSitemap().then((response) => {
        commit('setSitemap', response.data);
        return response.data;
      });
    },
  },
};
